const Splash = () => import('../views/common/splash.vue').then(m => m.default || m);
const Auth = () => import('../views/common/auth.vue').then(m => m.default || m);
const Main = () => import('../views/dive/index.vue').then(m => m.default || m);
const Camera = () => import('../views/dive/camera.vue').then(m => m.default || m);
const Login = () => import('../views/user/login.vue').then(m => m.default || m);
const FPw = () => import('../views/user/fpw.vue').then(m => m.default || m);
const Join = () => import('../views/join/join.vue').then(m => m.default || m);
const Pass = () => import('../views/join/pass.vue').then(m => m.default || m);
const RePass = () => import('../views/join/repass.vue').then(m => m.default || m);
const Complete = () => import('../views/join/complete.vue').then(m => m.default || m);
const Terms = () => import('../views/common/terms.vue').then(m => m.default || m);
const Privacy = () => import('../views/common/privacy.vue').then(m => m.default || m);
const License = () => import('../views/common/license.vue').then(m => m.default || m);
const Device = () => import('../views/device/index.vue').then(m => m.default || m);
const Scan = () => import('../views/device/scan.vue').then(m => m.default || m);
const Perm = () => import('../views/common/perm.vue').then(m => m.default || m);
const Gallery = () => import('../views/gallery/index.vue').then(m => m.default || m);
const Collection = () => import('../views/coll/index.vue').then(m => m.default || m);
const GallMore = () => import('../views/gallery/more.vue').then(m => m.default || m);
const GallList = () => import('../views/gallery/list.vue').then(m => m.default || m);
const CollMore = () => import('../views/coll/more.vue').then(m => m.default || m);
const CollList = () => import('../views/coll/list.vue').then(m => m.default || m);
const CollReg = () => import('../views/coll/reg.vue').then(m => m.default || m);
const CollEdit = () => import('../views/coll/edit.vue').then(m => m.default || m);
const CollPic = () => import('../views/coll/pics.vue').then(m => m.default || m);
const FilterPic = () => import('../views/gallery/pics.vue').then(m => m.default || m);
const Mypage = () => import('../views/user/index.vue').then(m => m.default || m);
const Setting = () => import('../views/setting/index.vue').then(m => m.default || m);
const Service = () => import('../views/setting/service.vue').then(m => m.default || m);
const Appinfo = () => import('../views/setting/appinfo.vue').then(m => m.default || m);
const Account = () => import('../views/setting/account.vue').then(m => m.default || m);
const Tutorial = () => import('../views/setting/tutorial.vue').then(m => m.default || m);
const ChangePw = () => import('../views/user/pchange.vue').then(m => m.default || m);
const Media = () => import('../views/media/index.vue').then(m => m.default || m);
const Notice = () => import('../views/notice/index.vue').then(m => m.default || m);
const NoticeDetail = () => import('../views/notice/detail.vue').then(m => m.default || m);
const Faq = () => import('../views/faq/index.vue').then(m => m.default || m);
const FaqList = () => import('../views/faq/list.vue').then(m => m.default || m);
const FaqDetail = () => import('../views/faq/detail.vue').then(m => m.default || m);
const Qna = () => import('../views/qna/index.vue').then(m => m.default || m);
const QnaDetail = () => import('../views/qna/detail.vue').then(m => m.default || m);
const QnaReg = () => import('../views/qna/reg.vue').then(m => m.default || m);
const SuggReg = () => import('../views/sugg/reg.vue').then(m => m.default || m);
const Contract = () => import('../views/contract/reg.vue').then(m => m.default || m);
const MyInfo = () => import('../views/user/info.vue').then(m => m.default || m);
const Test = () => import('../views/test.vue').then(m => m.default || m);
export default [
    {
        path: '',
        name: 'splash',
        component: Splash,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/auth',
        name: 'auth',
        component: Auth,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/main',
        name: 'main',
        component: Main,
        props: true,
        meta: { footer: true }
    },
    {
        path: '/camera',
        name: 'camera',
        component: Camera,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/fpw',
        name: 'fpw',
        component: FPw,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/join',
        name: 'join',
        component: Join,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/pass',
        name: 'pass',
        component: Pass,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/repass',
        name: 'repass',
        component: RePass,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/complete',
        name: 'complete',
        component: Complete,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/terms',
        name: 'terms',
        component: Terms,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/license',
        name: 'license',
        component: License,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: Privacy,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/device',
        name: 'device',
        component: Device,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/scan',
        name: 'scan',
        component: Scan,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/perm',
        name: 'perm',
        component: Perm,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/filter',
        name: 'filterPic',
        component: FilterPic,
        props: true,
        meta: { footer: true }
    },
    {
        path: '/logbook/gallery',
        name: 'gallery',
        component: Gallery,
        props: true,
        meta: { footer: true }
    },
    {
        path: '/logbook/gallery/more',
        name: 'gallMore',
        component: GallMore,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/gallery/list/:seq',
        name: 'gallList',
        component: GallList,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/coll',
        name: 'coll',
        component: Collection,
        props: true,
        meta: { footer: true }
    },
    {
        path: '/logbook/coll/more',
        name: 'collMore',
        component: CollMore,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/coll/list/:seq',
        name: 'collList',
        component: CollList,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/coll/reg',
        name: 'collReg',
        component: CollReg,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/coll/edit/:seq',
        name: 'collEdit',
        component: CollEdit,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/logbook/coll/pics',
        name: 'collPic',
        component: CollPic,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/media/:seq',
        name: 'media',
        component: Media,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/mypage',
        name: 'mypage',
        component: Mypage,
        props: true,
        meta: { footer: true }
    },
    {
        path: '/myinfo',
        name: 'myinfo',
        component: MyInfo,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/setting',
        name: 'setting',
        component: Setting,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/service',
        name: 'service',
        component: Service,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/appinfo',
        name: 'appinfo',
        component: Appinfo,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/account',
        name: 'account',
        component: Account,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/tutorial',
        name: 'tutorial',
        component: Tutorial,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/pchange',
        name: 'pchange',
        component: ChangePw,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/notice',
        name: 'notice',
        component: Notice,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/notice/detail',
        name: 'noticeDetail',
        component: NoticeDetail,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/faq',
        name: 'faq',
        component: Faq,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/faq/list',
        name: 'faqList',
        component: FaqList,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/faq/detail',
        name: 'faqDetail',
        component: FaqDetail,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/qna',
        name: 'qna',
        component: Qna,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/qna/detail',
        name: 'qnaDetail',
        component: QnaDetail,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/qna/reg',
        name: 'qnaReg',
        component: QnaReg,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/contract',
        name: 'contract',
        component: Contract,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/sugg/reg',
        name: 'suggReg',
        component: SuggReg,
        props: true,
        meta: { footer: false }
    },
    {
        path: '/test',
        name: 'test',
        component: Test,
        props: true,
        meta: { footer: false }
    },
    {
        path: '*',
        redirect: '/',
    },
]